import { useState } from 'react'
import Card from '../Card'
import Page from '../Page'
import { isEmpty } from 'lodash'
import $t from '../../../i18n'
import MaterialInput from '../MaterialInput'
import { Button } from 'antd'
import Actions from '../../../actions'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { event, eventTypes } from '../../../consts/eventConsts'
import {
  getOwnerMember,
  getMemberEmail,
  getMemberZipCode
} from 'utils/memberUtils'
import { REJECT_ENROLLMENT_REASONS } from 'consts/flowConsts'
import useMediaQuery from 'hooks/useMediaQuery'

import './RejectEnrollmentPage.css'
import { WEBSITE_URL } from 'consts'

const getValidationErrors = ({ email }) => {
  const result = {}

  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (!email || !email?.toLowerCase().match(EMAIL_REGEX)) {
    result.email = $t('errors.validation.invalidEmail')
  }

  return (!isEmpty(result) && result) || null
}

const RejectEnrollmentPage = ({ reason }) => {
  const dispatch = useDispatch()

  const [shouldValidate, setShouldValidate] = useState(false)

  const isMobile = useMediaQuery('(max-width: 600px)')

  const isEmailSent = useSelector(
    state => state?.application?.subsribedToWaitingListSucceded
  )
  const ownerMember = useSelector(state =>
    getOwnerMember(state?.member?.members)
  )
  const email = getMemberEmail(ownerMember)
  const zipCode = getMemberZipCode(ownerMember)

  const errors = shouldValidate && getValidationErrors({ email })

  const onNotifyRequest = () => {
    const validationErrors = getValidationErrors({ email })
    if (validationErrors) {
      setShouldValidate(true)
      return
    }
    setShouldValidate(false)
    if (reason === REJECT_ENROLLMENT_REASONS.NON_VALID_STATE) {
      dispatch(
        Actions.createAction(
          Actions.SUBSCRIBE_TO_STATE_WAITING_LIST_REQUESTED,
          {
            email,
            zipCode
          }
        )
      )
    }
    if (reason === REJECT_ENROLLMENT_REASONS.NON_ELIGIBLE) {
      dispatch(
        Actions.createAction(
          Actions.SUBSCRIBE_TO_ENROLLMENT_REASON_WAITING_LIST_REQUESTED,
          {
            email
          }
        )
      )
    }

    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: { email },
        element: 'Keep me updated'
      })
    )
  }

  return (
    <Card className='reject-card'>
      <Page
        canNavigateBack={false}
        className={isEmailSent ? 'reject-page success' : 'reject-page'}
        title={
          isEmailSent
            ? $t('messagePage.reminderSent.title')
            : $t(`messagePage.${reason}.title`)
        }
        subtitle={
          isEmailSent
            ? $t('messagePage.reminderSent.subtitle', { email })
            : $t(`messagePage.${reason}.subtitle`)
        }
        image={
          isEmailSent
            ? 'success.svg'
            : isMobile
            ? 'state-mobile.svg'
            : 'state.svg'
        }
      >
        <div className='reject-content'>
          <div className='semi-bold reject-page-desc'>
            {isEmailSent
              ? $t('messagePage.reminderSent.description')
              : $t(`messagePage.${reason}.description`, { defaultValue: '' })}
          </div>
          {!isEmailSent && (
            <MaterialInput
              className='contact-input'
              value={email}
              type='email'
              errorText={errors?.email}
              onChange={e => {
                dispatch(
                  Actions.createAction(Actions.UPDATE_OWNER_MEMBER_EMAIL, {
                    email: e.target.value
                  })
                )
              }}
              label={$t('fields.email')}
            />
          )}
          {!isEmailSent && (
            <Button
              className='see-plans-btn'
              type='primary'
              onClick={onNotifyRequest}
            >
              {$t('messagePage.keepUpdated')}
            </Button>
          )}
          {isEmailSent && (
            <Button
              className='learn-more-btn trackable'
              data-name='learn more clicked'
              type='primary'
              onClick={() => window.open(WEBSITE_URL)}
            >
              {$t('messagePage.learnMore')}
            </Button>
          )}
        </div>
      </Page>
    </Card>
  )
}

export default RejectEnrollmentPage
